import React from 'react';
import { useI18n } from '../context/I18nContext';

const techs = [
  'C++', 'Python', 'MySQL', 'PHP', 'Node.js', 'React', 'Docker', 'Nginx', 'Redis', 'LiteSpeed',
  'Cloudflare', 'AMD Ryzen', 'DDoS Guard', 'NVMe', 'XenForo', 'WordPress', 'AWS', 'Google Cloud',
];

export default function TechMarquee() {
  const { tr } = useI18n();
  const doubled = [...techs, ...techs];
  return (
    <section className="relative py-14 border-y border-[#e4b44e]/15 bg-[#08080b] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-8 flex items-center justify-between">
        <div className="text-xs font-bold tracking-[0.32em] text-[#e4b44e]/85">{tr('marquee.eyebrow', 'TEKNOLOJİ YIĞINI')}</div>
        <div className="text-xs text-white/40">{tr('marquee.stats', '40+ ülke · 500+ sunucu · %99.9 uptime')}</div>
      </div>
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#08080b] to-transparent z-10" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#08080b] to-transparent z-10" />
        <div className="flex gap-12 animate-marquee whitespace-nowrap">
          {doubled.map((t, i) => (
            <div key={i} className="font-display text-3xl md:text-4xl font-bold text-white/25 hover:text-[#f4d896] transition">
              {t}
              <span className="ml-12 text-[#e4b44e]/40">✦</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
